import React, { useEffect, useState } from 'react'
import { getLabel } from '../../../../common/getLabel'
import { useFormik } from "formik";
import { deleteTestimonial, getTestimonials, setupTestimonials } from '../../../services/account/action';
import { baseUrl } from '../../../common/config';

const Testimonials = (props) => {
    const { profileId, useDynamicFields } = props;
    const { fields: testimonialField, setFields: setTestimonialFields, addField: addTestimonialFields, removeField: removeTestimonialField, handleChange: handleTestimonialField } = useDynamicFields({
        pt_id: 0,
        testimonial_image: 0,
        pt_username: '',
        pt_content: ''
    });
    useEffect(() => {
        loadTestimonials();
    }, []);

    const [fileData, setFileData] = useState({});
    const [previewImages, setPreviewImages] = useState({});
    const filteredTestiminialFields = testimonialField.filter(item => item.pt_id !== '' || item.testimonial_image !== '' || item.pt_username !== '' || item.pt_content !== '');
    const loadTestimonials = async () => {
        const response = await getTestimonials({ "profileId": profileId });
        if(response && response.length > 0){
            setTestimonialFields(response);
        }
    }

    const formik = useFormik({
        initialValues: {},
        validateOnChange: false,
        onSubmit: async (values) => {
            const formData = new FormData();
            let imageIndex = 0;
            filteredTestiminialFields.forEach((field, index) => {
                let testimonial_image_index = null;
                formData.append(`pt_id[${index}]`, field.pt_id);
                formData.append(`pt_username[${index}]`, field.pt_username);
                formData.append(`pt_content[${index}]`, field.pt_content);
                if (fileData[index]) {
                    fileData[index].forEach((file) => {
                        formData.append(`testimonial_image`, file);
                    });
                    testimonial_image_index = imageIndex;
                    imageIndex++;
                }
                formData.append(`testimonial_image_index[${index}]`, testimonial_image_index);
            });
            formData.append(`profile_id`, profileId);
            try {
                await setupTestimonials(formData);
            } catch (error) {
                console.log(error);
            }
        },
    });

    const handleFileChange = (e, index) => {
        const files = Array.from(e.target.files);
        const updatedFields = [...testimonialField];
        updatedFields[index].testimonial_image = files;
        setTestimonialFields(updatedFields);
        setFileData(prevState => ({
            ...prevState,
            [index]: files
        }));

        const newPreviewImages = { ...previewImages };
        const file = files[0];
        if (file) {
            const previewUrl = URL.createObjectURL(file);
            newPreviewImages[index] = previewUrl;
            setPreviewImages(newPreviewImages);
        }
    };

    const handleDeleteEvent = async (testimonialId, index) => {
        if (testimonialId) {
            const response = await deleteTestimonial({ "testimonialId": testimonialId });
            if (response === true) {
                removeTestimonialField(index)
            }
        } else {
            removeTestimonialField(index)
        }
    }

    return (
        <>
            <h4>{getLabel('LBL_Testimonials')}</h4>
            <form onSubmit={formik.handleSubmit}>
                <div className="row bg-white-tranier mb-5">
                    {testimonialField.map((field, index) => (
                        <div className="col-lg-12" key={index}>
                            <div className="row">
                                <div className="col-lg-3">
                                    <input
                                        className="form-control"
                                        type="file"
                                        name={`testimonial_image[${index}]`}
                                        id={`testimonial_image[${index}]`}
                                        multiple
                                        onChange={(e) => handleFileChange(e, index)}
                                    />
                                    {previewImages[index] ? (
                                        <div>
                                            <img
                                                src={previewImages[index]}
                                                style={{
                                                    height: "100px",
                                                    width: "100px",
                                                    borderRadius: "50%",
                                                }}
                                                alt="image-preview"
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            {field.images && Object.keys(field.images).length > 0 && (
                                                <div>
                                                    <img
                                                        src={`${baseUrl}/${field.images[0].afile_physical_path}`}
                                                        style={{
                                                            height: "100px",
                                                            width: "100px",
                                                            borderRadius: "50%",
                                                        }}
                                                        alt="image-path"
                                                    />
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                                <div className="col-lg-3">
                                    <div className="form-group">
                                        <input type="text" name={`pt_username[${index}]`} className="form-control" placeholder={getLabel('LBL_User_name')} aria-label="College" value={field.pt_username} onChange={(e) => handleTestimonialField(index, 'pt_username', e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-lg-5">
                                    <div className="form-group bio">
                                        <textarea rows="4" placeholder={getLabel('LBL_Content')} name={`pt_content[${index}]`} value={field.pt_content} onChange={(e) => handleTestimonialField(index, 'pt_content', e.target.value)}></textarea>
                                    </div>
                                </div>
                                <input type="hidden" name="pt_id" value={field.pt_id} />
                                {index > 0 && (
                                    <div className="col-lg-1 required_inp">
                                        <div className="form-group">
                                            <input type="button" className="inputRemove" value="X" onClick={() => handleDeleteEvent(field.pt_id, index)} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                    <div className="col-lg-12">
                        <div className="add-more">
                            <button type="button" className="add_input" onClick={addTestimonialFields}><i className='bx bx-plus'></i> {getLabel('LBL_Add_Testimonials')}</button>
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <div className="from-group">
                            <button type="submit" className="btn btn-default btn-sm btn-save btn-umber">Save changes</button>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}

export default Testimonials
